<template>
  <div
    :class="[
      activeIndex == 0 ? 'bg-introduce2' : activeIndex == 1 ? 'bg-introduce3' : 'bg-introduce',
    ]"
  ></div>
  <div class="page industry">
    <base-left-content :Top="paddingTop">
      <industrial-parks title="招商分析"></industrial-parks>
      <business-data></business-data>
      <star-enterprise></star-enterprise>
    </base-left-content>
    <base-right-content :Top="paddingTop">
      <park-area></park-area>
      <operation-overview></operation-overview>
      <Top5></Top5>
    </base-right-content>
    <div class="switch-wrapper">
      <div
        class="btn"
        v-for="(item, index) in switchBtn"
        :key="item"
        :style="{
          background: `url(${activeIndex !== index ? item.btn : item.btn_active})`,
          backgroundSize: '100% 100%',
        }"
        @click="handleClick(index)"
      ></div>
    </div>
    <template v-if="activeIndex != 1">
      <building-btn-3
        class="building-btn"
        v-for="item in buildingBtnData2"
        :key="item.id"
        :data="item"
      ></building-btn-3>
    </template>

    <BuildingModal3 :show="buildingDialog3" @close="handleCloseProject" />
  </div>
</template>

<script setup>
import { useOverViewStore } from '@/store/index';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import BaseLeftContent from '@/baseCpm/BaseLeftContent/BaseLeftContent.vue';
import BaseRightContent from '@/baseCpm/BaseRightContent/BaseRightContent.vue';
import BusinessData from './cpm/BusinessData.vue';
import StarEnterprise from './cpm/StarEnterprise.vue';
import ParkArea from './cpm/ParkArea.vue';
import Top5 from './cpm/Top5.vue';
import IndustrialParks from '@/components/commonCpm/IndustrialParks';
import OperationOverview from './cpm/OperationOverview';
import BuildingBtn3 from '@/components/commonCpm/BuildingBtn3.vue';
import BuildingModal3 from '@/components/commonCpm/BuildingModal3.vue';

// import Flow from '@/components/commonCpm/Flow';
const store = useOverViewStore();
let { pageIndex } = storeToRefs(store);
let paddingTop = ref(107);
const btn1 = require('@/assets/images/Situation/btn_1.png');
const btn2 = require('@/assets/images/Situation/btn_2.png');
const btn1_active = require('@/assets/images/Situation/btn_1_active.png');
const btn2_active = require('@/assets/images/Situation/btn_2_active.png');
let switchBtn = ref([
  {
    btn: btn1,
    btn_active: btn1_active,
  },
  {
    btn: btn2,
    btn_active: btn2_active,
  },
]);
const activeIndex = ref(-1);
const handleClick = (index) => {
  if (activeIndex.value != index) {
    activeIndex.value = index;
    if (activeIndex.value == 0) {
      buildingDialog3.value = true;
    }
  } else {
    activeIndex.value = -1;
  }
};
pageIndex.value = 0;
const buildingBtnData2 = [
  {
    id: 1,
    text: '宿舍楼1',
    position: {
      x: 1241,
      y: 380,
    },
  },
  {
    id: 2,
    text: '宿舍楼2',
    active: false,
    position: {
      x: 1399,
      y: 285,
    },
  },
  {
    id: 3,
    text: '综合楼1',
    position: {
      x: 783,
      y: 620,
    },
  },
  {
    id: 4,
    text: '综合楼2',
    position: {
      x: 1016,
      y: 488,
    },
  },
  {
    id: 5,
    text: '加工车间1',
    active: false,
    position: {
      x: 591,
      y: 468,
    },
  },
  {
    id: 6,
    text: '加工车间2',
    active: false,
    position: {
      x: 793,
      y: 269,
    },
  },
  {
    id: 7,
    text: '冷库',
    active: false,
    position: {
      x: 727,
      y: 340,
    },
  },
  {
    id: 8,
    text: '快速车间1',
    active: true,
    position: {
      x: 949,
      y: 163,
    },
  },
  {
    id: 9,
    text: '快速车间2',
    active: false,
    position: {
      x: 1134,
      y: 100,
    },
  },
  {
    id: 10,
    text: '快速车间3',
    active: false,
    position: {
      x: 1154,
      y: 295,
    },
  },
  {
    id: 11,
    text: '标准厂房',
    active: false,
    position: {
      x: 1391,
      y: 145,
    },
  },
  {
    id: 12,
    text: '配电房',
    active: false,
    modal: false,
    position: {
      x: 758,
      y: 779,
    },
  },
];

const buildingDialog3 = ref(false);
const handleCloseProject = () => {
  buildingDialog3.value = false;
};
</script>

<style lang="scss" scoped>
@import './index.scss';
.bg-introduce {
  position: absolute;
  width: 1920px;
  height: 1080px;
  background-image: url(@/assets/images/bg/bg.png);
  background-size: 100% 100%;
  z-index: -2;
}
.bg-introduce2 {
  position: absolute;
  width: 1920px;
  height: 1080px;
  background-image: url(@/assets/images/bg/bg5.png);
  background-size: 100% 100%;
  z-index: -2;
}
.bg-introduce3 {
  position: absolute;
  width: 1920px;
  height: 1080px;
  background-image: url(@/assets/images/bg/bg6.png);
  background-size: 100% 100%;
  z-index: -2;
}
.switch-wrapper {
  position: fixed;
  bottom: 120px;
  left: 418px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 117.9px;
  // height: 138px;
  .btn {
    width: 117.9px;
    height: 39px;
    margin-top: 10px;
    cursor: pointer;
  }
}
</style>
